export default "__VITE_ASSET__xRIMJkP2__"